// extracted by mini-css-extract-plugin
export default {"cta":"Submit-module__cta___qSrQy","font":"Submit-module__font___BROjm"};